import { createRoot } from 'react-dom/client'

// Cache for React 18 roots
const rootCache = new WeakMap()

/**
 * React 18 compatible render function
 * This function manages the creation and reuse of React roots
 */
export function renderWithRoot (element, container) {
  let root = rootCache.get(container)
  
  if (!root) {
    root = createRoot(container)
    rootCache.set(container, root)
  }
  
  root.render(element)
  return root
}

/**
 * Unmount a React root
 */
export function unmountRoot (container) {
  const root = rootCache.get(container)
  if (root) {
    root.unmount()
    rootCache.delete(container)
  }
}
